<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Avsnittsrubrik
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Sidorubrik med dekorativ teal-understrykning. Används för att dela upp
      hemsida och kategorisidor i tydliga block.
    </p>

    <PreviewFull label="Enkel variant">
      <div>
        <h2
          class="font-[Poppins] font-bold text-[22px] text-[#191c1e] m-0 mb-2"
        >
          Nya recept
        </h2>
        <div class="w-10 h-0.5 bg-teal-500 rounded-full" />
      </div>
    </PreviewFull>

    <PreviewFull label="Med undertext">
      <div>
        <h2
          class="font-[Poppins] font-bold text-[22px] text-[#191c1e] m-0 mb-1"
        >
          Tekniker &amp; verktyg
        </h2>
        <div class="w-10 h-0.5 bg-teal-500 rounded-full mb-2" />
        <p class="font-[Plus_Jakarta_Sans] text-[14px] text-[#6c7a77] m-0">
          Guider och kalkylatorer för att bli en bättre hemmabagare
        </p>
      </div>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<div>
  <h2 class="font-[Poppins] font-bold text-[22px] text-[#191c1e] m-0 mb-2">Avsnittsrubrik</h2>
  <div class="w-10 h-0.5 bg-teal-500 rounded-full" />
  <!-- Valfri undertext -->
  <p class="font-[Plus_Jakarta_Sans] text-[14px] text-[#6c7a77] mt-2 m-0">
    Undertexten visas här
  </p>
</div>`;

const cssCode = `/* Rubrik */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 22px;

/* Teal understrykning */
width: 40px;      /* w-10 */
height: 2px;      /* h-0.5 */
background: #14b8a6;
border-radius: 9999px;

/* Undertext */
font-family: 'Plus Jakarta Sans', sans-serif;
font-size: 14px;
color: #6c7a77;
margin-top: 8px;  /* mt-2 */`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
</script>
